import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getModule } from "store/userSlice";

import Content from "./Content";
import { useTranslation } from "translation/useTranslation";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { isDbModule } from "helpers/module";

export default function PreviewModal({ settingName = null, show, handleClose, formData = null, employee = null, balancedScorecard = null, fetchBalancedScorecards = null, reviewerView = false, allowReportEmail = true, setContentDirty, isPreview = false }) {
  const { translate, editableTranslate } = useTranslation();

  const currentModule = useSelector(getModule);

  const isDbModuleActive = useMemo(() => {
    return isDbModule(currentModule);
  }, [currentModule]);

  useEffect(() => {
    document.body.style.overflowY = (show ? 'hidden' : 'auto');
  }, [show]);

  return show && <>
    <div className={`modal ${show ? 'fade show d-block' : ''} preview-balance-scorecard-modal`} tabIndex="-1" data-testid="show-modal">
      <div className="modal-dialog modal-dialog-scrollable modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            {
              isDbModuleActive ? <h5 className="font-weight-bold">{settingName || editableTranslate('balanced_scorecard.management')}</h5> :
                <h5 className="font-weight-bold">{editableTranslate('global.software_name', 'PEB')} {editableTranslate('global.menu.settings.balance_scorecard')} - {balancedScorecard?.balanced_scorecard_setting?.name || editableTranslate('balanced_scorecard.management')}</h5>
            }
            <span className="cursor-pointer font-weight-bold balanced-scorecard-close close" onClick={handleClose} data-testid="close-button"><i className="bi bi-x-lg"></i></span>
          </div>
          <div className="modal-body overflow-x-hidden">
            <div className="modal-body-div pt-3">
              <Content show={show} formData={formData} employee={employee} balancedScorecard={balancedScorecard} fetchBalancedScorecards={fetchBalancedScorecards} reviewerView={reviewerView} allowReportEmail={allowReportEmail} setContentDirty={setContentDirty} isModal={true} isPreview={isPreview} />
            </div>
          </div>
        </div>
      </div>
      <ReactTooltip id={`employee-number-tooltip`} place="bottom" clickable={true} content={employee?.employee_number} />
      <ReactTooltip id={`setting-name-tooltip`} place="bottom" content={balancedScorecard?.balanced_scorecard_setting?.name + ` (${balancedScorecard?.balanced_scorecard_setting?.description})`} />
    </div>
    <div className="modal-backdrop fade show"></div>
  </>
}
